@if (data !== null) {
  <bp-modal-header [title]="getHeaderTitle() | translate: [getCoin()?.getName()]">
    <a
      right
      class="hover-pointer large-weight"
      (click)="close()"
      (keydown.enter)="close()"
      [tabIndex]="0"
      data-dismiss="modal">
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div
			[ngClass]="{
				'bp-modal-body-section mod-wide pt-25 pb-0': accepted
			}">
      <div class="bp-modal-body-section mod-wide pt-25 pb-0" [ngClass]="{ 'mod-transparent': accepted }">
        <div class="bp-modal-description">{{ "summary_sub_header" | translate }}</div>
        <div class="summary-grid">
          <summary-grid
            step="1"
            titleKey="from_summary_send"
            class="summary-grid-item"
            [cssHover]="isHoverable()"
            (onStepClick)="setEdit($event)">
            <ng-container iconContainer>
              <div class="summary-card__currency-symbol mb-10">
                <img
                  [src]="getCoin()?.getLogo()"
                  [style.width.px]="42"
                  (error)="img.src = getCoin()?.getDefaultLogo()"
                  alt="{{ 'logo_alt_text' | translate }}"
                  #img />
              </div>
            </ng-container>
            <ng-container detailsContainer>
              <span class="summary-card__text text-word-break">{{ wallet?.getName() }}</span>
              <br />
              <span class="text-small-black">{{ getCoin()?.getName() }}</span>
              <br />
              @if ({
                isMultiChain: isMultichain$ | async,
                networkName: networkName$ | async
                }; as data) {
                @if (data.networkName && data.isMultiChain) {
                  <span class="text-small-black">
                    {{ "withdrawal_multichain_network_summary" | translate: [data.networkName] }}
                  </span>
                }
              }
            </ng-container>
          </summary-grid>
          <summary-grid
            step="2"
            titleKey="to_summary_send"
            class="summary-grid-item"
            [cssHover]="isHoverable()"
            (onStepClick)="setEdit($event)">
            <ng-container detailsContainer>
              @if (isContact()) {
                <div class="summary-card__contact-symbol mb-10">
                  {{ getContact()?.getMonogram() }}
                </div>
              }
              @if (!isExternalSend()) {
                <div>
                  @if (!isContact()) {
                    @if (data?.isInternalSendType() && isEmail()) {
                      <div
                        class="summary-card__email-symbol mb-10"
                        >
                        <span class="bpi__icon-email"></span>
                      </div>
                    }
                    @if (data?.isInternalSendType() && !isEmail()) {
                      <div>
                        <div
                        class="summary-card__external-symbol bpi__icon-send color-primary mb-10"></div>
                        <span class="summary-card__contact-name">
                          {{ "internal_address" | translate }}
                        </span>
                      </div>
                    }
                    @if (!data?.isInternalSendType()) {
                      <div
                        class="summary-card__currency-symbol mb-10"
                        >
                        <img
                          [src]="getCoin()?.getLogo()"
                          [style.width.px]="42"
                          (error)="img.src = getCoin()?.getDefaultLogo()"
                          alt="{{ 'logo_alt_text' | translate }}"
                          #img />
                      </div>
                    }
                  }
                </div>
                @if (isEmail()) {
                  <span class="summary-card__contact-name">
                    {{ "email" | translate }}
                  </span>
                }
              } @else {
                @if (!isContact()) {
                  <div class="summary-card__external-symbol bpi__icon-send color-primary mb-10"></div>
                  <div class="summary-card__contact-name">{{ "external_address" | translate }}</div>
                }
              }
              @if (isContact()) {
                <span class="summary-card__contact-name custom-word-break">
                  {{ data?.getContactName() }}
                </span>
              }
              <p class="text-small-black ml-10 custom-word-break">
                {{ data?.displayRecipient(data?.isInternalSendType(), isEmail()) }}
              </p>
            </ng-container>
          </summary-grid>
          <summary-grid
            step="3"
            titleKey="amount"
            class="summary-grid-item"
            [cssHover]="isHoverable()"
            (onStepClick)="setEdit($event)">
            <ng-container detailsContainer>
              <div class="text-big-black line-height-26 pb-5">
                <strong>{{ cryptoStringArray[0] + cryptoStringArray[1] }}</strong>
                <span class="font-size-13">{{ cryptoStringArray[2] }}</span>
                {{ getCoin()?.getSymbol() }}
              </div>
              <div class="text-small-black"
                >&asymp;&nbsp;{{
                +data?.getAmountFiat() + feeAmountFiat
                | fiat_precision_symbol
                : { id: getFiat()?.getId(), currencies: [getFiat()], symbol: true }
                }}
              </div>
              @if (isExternalSend()) {
                <div class="text-small-black pt-5">
                  {{ "inkl" | translate }}
                  {{
                  feeAmountFiat
                  | fiat_precision_symbol
                  : {
                  id: fiat?.getId(),
                  prefix: feeAmountFiat < 0.01,
                  symbol: true,
                  currencies: [fiat]
                }
                }}
                {{ "fees" | translate | lowercase }}
              </div>
            }
          </ng-container>
        </summary-grid>
      </div>
      @if (!isExternalSend()) {
        <div class="flex-grow-1 mb-10">
          <textarea
            placeholder="{{ 'optional_purpose_text' | translate }}"
            [(ngModel)]="data._purpose_text"
            [maxlength]="140"
          class="form-field form-field--light input-lg no-horizontal-resize"></textarea>
        </div>
      }
    </div>
  </div>
  <span class="bp-modal-body-2fa" style="align-content: center">
    @if (accepted) {
      <two-fa (save)="save($event)"></two-fa>
    }
  </span>
  <!--
  *
  *
  *   BOTTOM
  *
  *
  -->
  @if (showSliders()) {
    <div class="mb-10">
      <div class="bp-modal-body-upper pt-0">
        <!-- Check slider for "Valid address" -->
        <bp-switch [model]="this" field="coinValid">
          @if ((isMultichain$ | async) === false) {
            <div left>
              <div left>
                <span class="text-medium-black large-weight">
                  {{ "withdrawal_multichain_toggle_info" | translate }}
                </span>
                <a [href]="getSummaryToolTipLink()" [target]="'_blank'" [tabIndex]="-1">
                  <span
                    class="ml-5 bpi__icon-info font-size-16 color-primary shift-down"
                    [bp-tooltip]="'send_external_tooltip' | translate"
                    position="top"
                    (keydown.enter)="getSummaryToolTipLink()"
                  [tabIndex]="0"></span>
                </a>
              </div>
              <div left>
                <span class="font-size-13 line-height-20">
                  {{ "crypto_send_info" | translate: [getCoin()?.getSymbol()] }}
                </span>
              </div>
            </div>
          } @else {
            <div left>
              <span class="font-size-13">
                {{ "withdrawal_multichain_toggle_info" | translate }}
              </span>
            </div>
          }
        </bp-switch>
        <!-- Check slider for "Investing in ICO" -->
        @if (showICOInvestingSlider()) {
          <bp-switch [model]="this" field="checkedICOInvesting">
            <div left>
              <span class="text-medium-black large-weight">
                {{ "send_summary_investing_ico_title" | translate }}
              </span>
              <a [href]="getSummaryToolTipLink()" [target]="'_blank'" [tabIndex]="-1">
                <span
                  class="bpi__icon-info font-size-16 color-primary shift-down"
                  [bp-tooltip]="'send_summary_investing_ico_tooltip' | translate"
                  position="top"
                  (keydown.enter)="getSummaryToolTipLink()"
                [tabIndex]="0"></span>
              </a>
            </div>
            <div left>
              <span class="font-size-13 line-height-20">
                {{ "send_summary_investing_ico_description" | translate: [getCoin()?.getSymbol()] }}
              </span>
            </div>
          </bp-switch>
        }
      </div>
    </div>
  }
  <!-- Confirm button -->
  <!-- no 2FA -->
  @if (!needs2fa()) {
    <div style="text-align: center">
      <button
        class="btn btn-primary btn-summary mod-send btn-lg"
        [ngClass]="{ disabled: isConfirmButtonDisabled() }"
        type="button"
        (click)="save()">
        {{ "summary_button_confirm" | translate }}
      </button>
    </div>
  } @else {
    <div style="text-align: center">
      @if (!accepted) {
        <div>
          <button
            class="btn btn-primary btn-summary mod-send btn-lg"
            [ngClass]="{ disabled: isConfirmButtonDisabled() }"
            type="button"
            (click)="TwoFAClick()">
            {{ "summary_button_confirm" | translate }}
          </button>
        </div>
      }
    </div>
  }
  <!-- with 2FA -->
</div>
}
